import { alpha, styled } from '@mui/material/styles'
import { useResourceDefinition, useSidebarState } from 'react-admin'
// import { LocalesMenuButton } from '../buttons'
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
// components
import Searchbar from './Searchbar'
// import NotificationsPopover from './NotificationsPopover'
import AccountPopover from './AccountPopover'
import { useUserContextProvider } from '../../contexts/user-context'
import { useRouteExtract } from '../../hooks'
import { useMemo } from 'react'
const DRAWER_WIDTH = 280
const APPBAR_MOBILE = 64
const APPBAR_DESKTOP = 92

const AppBarStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}))

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}))

const CustomAppBar = (): JSX.Element => {
  const { currentUserData } = useUserContextProvider()
  const [open, setSideBar] = useSidebarState()
  const { pathSegments } = useRouteExtract()
  const [currentResource = ''] = pathSegments
  const resource = useResourceDefinition({ resource: currentResource })
  const isShowSearchBar = useMemo(
    () => resource.options?.isGlobalSearch && pathSegments.length <= 1,
    [pathSegments.length, resource.options?.isGlobalSearch],
  )

  const handleToggle = (): void => setSideBar(!open)
  return (
    <AppBarStyle>
      <ToolbarStyle>
        <IconButton
          onClick={handleToggle}
          sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}
        >
          <MenuRoundedIcon />
        </IconButton>
        {isShowSearchBar || currentResource == '' ? <Searchbar /> : null}
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction='row' alignItems='center' spacing={{ xs: 0.5, sm: 1.5 }}>
          {/* <LocalesMenuButton
            languages={[
              // { locale: 'en', name: 'English', icon: '/icons/en-flag.svg' },
              { locale: 'th', name: 'Thai', icon: '/icons/th-flag.svg' },
            ]}
          /> */}
          {/* <NotificationsPopover /> */}
          <AccountPopover identity={currentUserData} />
        </Stack>
      </ToolbarStyle>
    </AppBarStyle>
  )
}

export default CustomAppBar
